import moment from "moment";

import { parseOxygenDateRange } from "@/react/datetime";

/**
 * The initial range is simply 1 month in the past to now.
 */
export const initialRange = {
  startDate: moment().subtract(1, "month").startOf("day").toDate(),
  endDate: moment().endOf("day").toDate(),
};

export const parseDateRange = (data) =>
  parseOxygenDateRange(data, initialRange);
